import React from "react";
import { SECTION_VERTICAL_SPACING } from "../../styles/spacing";

type SectionVerticalSpaceProps = {};

export const SectionVerticalSpace = (props: SectionVerticalSpaceProps) => {
  return <div style={{ height: SECTION_VERTICAL_SPACING }} />;
};
